import { render, staticRenderFns } from "./goExchange.vue?vue&type=template&id=1d8042cb&"
import script from "./goExchange.vue?vue&type=script&lang=js&"
export * from "./goExchange.vue?vue&type=script&lang=js&"
import style0 from "./goExchange.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports